import React, { useCallback, useEffect, useRef, useState } from 'react'
import { CategoryContainer } from '../../../../app/Components/Product/CategoryContainer';
import { revertQuantity } from '../HelperFunctions';

export const AddToCartModal = ({ updateCart, setUpdateCart, setItems }) => {
    const hasErrorGlobal = useRef(false);
    const escFunction = useCallback((event) => { if (event.key === "Escape") setUpdateCart(null) }, []);
    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => document.removeEventListener("keydown", escFunction, false)
    }, [escFunction]);
    useEffect(() => {
        if (updateCart.GlobalError === 'QuoteProvided') {
            hasErrorGlobal.current = true;
            updateCart.ItemList.forEach((item, i) => {
                item.UoMPrices.forEach((uom, j) => { if (!!Math.abs(uom.QtyDiff)) revertQuantity(updateCart, i, j); })
            })
        }
        if (hasErrorGlobal.current) setItems([...updateCart.ItemList])
    }, []);

    if (!updateCart.ItemsAdded && !updateCart.ItemsRemoved && updateCart.GlobalError !== 'QuoteProvided' && updateCart.GlobalError != null) return;
    return (<>
        <div className="tw-flex tw-relative tw-flex-col sm:tw-w-[511px] tw-top-0 tw-z-[19] tw-bottom-0 tw-my-auto tw-h-fit tw-bg-white">
            <div className="tk-trade-gothic-next tw-text-mine-shaft-950 tw-flex tw-flex-col">
                <CloseButton updateCart={updateCart} setUpdateCart={setUpdateCart} bypassCheck={true} />
                <div className="tw-overflow-auto tw-max-h-[680px]">
                    {updateCart.GlobalError === 'QuoteProvided'
                        ? <div className="tw-pl-[13px] sm:tw-pl-[1rem] sm:tw-mx-[24px] tw-p-[1rem] tw-pb-[0.5rem] tw-pl-0" >
                            <h5 className="modal-title tw-flex tw-pb-[6px] tw-font-bold tw-text-[22px] tw-text-left"
                                style={{ borderBottom: "1.5px solid #282828" }}>
                                Cart Notification
                            </h5>
                            <div className="tw-px-[6px] tw-mt-[18px] tw-pb-[24px]" style={{ borderBottom: "1.5px solid #282828" }}>
                                <strong>We're sorry, but this cart is locked to modifications.</strong>
                                <p className="tw-mt-[10px]">
                                    Please start a new cart or contact&nbsp;
                                    <a className='text-primary' href='mailto:quotes@life-assist.com'>quotes@life-assist.com</a>
                                    &nbsp;or Customer Care at <a className='text-primary' href='tel:800-824-6016'>800-824-6016</a>
                                    &nbsp;to request additions or modifications to this cart.
                                </p>
                                <p className='my-1'>We'd be happy to assist you!</p>
                                <p>Please reference Cart No. <span className="tw-text-tamarillo-700">{window.cartVM.header.LocalKey()}</span></p>
                            </div>
                        </div>
                        : <><NothingToAdd updateCart={updateCart} />
                            <ItemsToAdd updateCart={updateCart} hasErrorGlobal={hasErrorGlobal} setItems={setItems} setUpdateCart={setUpdateCart} />
                            <ItemsToRemove updateCart={updateCart} hasErrorGlobal={hasErrorGlobal} /></>
                    }
                </div>
                {!updateCart?.RestrictionTypes?.length && <Footer updateCart={updateCart} setUpdateCart={setUpdateCart} />}
            </div>
        </div></>
    )
}

const Header = ({ numberOfItems }) => {
    const absItems = Math.abs(numberOfItems);
    const noOfItems = absItems > 1 ? 'Items' : absItems == 1 ? 'Item' : ''
    return (
        <div className="sm:tw-mx-[24px] tw-p-[1rem] tw-pb-[0.5rem]" style={numberOfItems === 0 ? { borderBottom: "1.5px solid #282828" } : {}} >
            <h5 className="modal-title tw-flex tw-gap-[6px] tw-font-bold tw-text-[22px] sm:tw-text-[24px]">
                {!numberOfItems ?
                    "Cart Notification"
                    : <>
                        {numberOfItems > 0 && <img width='24' src='/Content/img/sprites/instock-alert.svg' className="tw-mr-[5px]" />}
                        <span>{`${absItems} ${noOfItems} ${numberOfItems > 0 ? 'Added to Cart' : 'Removed From Cart'}`}</span>
                    </>
                }
            </h5>
        </div>
    );
}

const NothingToAdd = ({ updateCart }) => {
    return (
        !updateCart.ItemList.length && <>
            <Header numberOfItems={0} />
            <div className="modal-body tw-pl-[42px] tw-pr-[2rem] tw-pt-[1rem] tw-pb-0">
                No items in cart to update. Please select a quantity amount.
            </div></>
    )
}

const ItemsToAdd = ({ updateCart, hasErrorGlobal, setItems, setUpdateCart }) => {
    const [response, setResponse] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const onlyAdding = !!updateCart.ItemsAdded && !updateCart.ItemsRemoved;

    if (onlyAdding && !updateCart?.RestrictionTypes?.length && !response) {
        $.ajax({
            url: '/products/GetNewCartProducts/',
            async: true,
            type: 'POST',
            success: function (response) {
                if (window.innerWidth < 576 && !!response?.itemGroupModel?.length) response.itemGroupModel.splice(-1);
                setResponse(response);
            }
        })
    }

    return (
        <>{!!updateCart.ItemsAdded && <Header numberOfItems={updateCart.ItemsAdded} />}
            {updateCart.ItemList.map((item, i) => {
                return !!item.UoMPrices.some(uom => uom.QtyDiff > 0) &&
                    <div key={`item-to-add-${i}`} className="tw-flex tw-flex-col sm:tw-mx-[26px] tw-items-center tw-px-[10px]">
                        {item.AddToContract !== 'Y' ?
                            item.UoMPrices.map((uom, j) => (uom.QtyDiff > 0 && (uom.MessageCode === 'Success' || uom.MessageCode === 'AddToContract')) &&
                                <div key={`contract-item-${j}`} className="tw-w-full tw-pb-[24px] tw-pt-[13px]" style={{ borderBottom: "1.5px solid #A2A2A2" }}>
                                    <UoMDetails updateCart={updateCart} itemIndex={i} uomIndex={j} hasErrorGlobal={hasErrorGlobal} />
                                </div>)
                            :
                            <><UoMDetails key={`noncontract-item-${i}`} updateCart={updateCart} itemIndex={i} uomIndex={null} hasErrorGlobal={hasErrorGlobal} />
                                <div style={{ borderBottom: "1.5px solid #A2A2A2" }} className="contract-container tw-pb-[5px] tw-w-full tw-relative">
                                    <div className="tw-text-[15px] tw-pl-[10px] tw-pr-[6px] sm:tw-px-[16px] tw-rounded-[5px] tw-mb-[12px]" style={{ border: "1.5px solid #A2A2A2" }}>
                                        <div className="tw-flex tw-justify-between tw-w-full tw-cursor-pointer">
                                            <div className="contract-opener tw-pt-[6px] tw-pb-[8px] tw-italic tw-text-[14px] sm:tw-text-[15px]">
                                                Special Discount Available
                                            </div>
                                            <div className="tw-flex tw-gap-[10px] sm:tw-gap-[18px]">
                                                <div className="contract-message tw-italic tw-text-[15px] tw-content-center tw-mb-[3px]" style={{ display: "none" }}></div>
                                            </div>
                                        </div>
                                        <div className="contract-menu tw-text-[14px] sm:tw-text-[17px]">
                                            <div className="tw-flex tw-pl-[6px] tw-pt-[10px] tw-overflow-auto tw-flex-col sm:tw-flex-row tw-gap-x-[14px]">
                                                {item.UoMPrices.map((uom, j) =>
                                                    <div key={`contract-uom-${j}`} className="tw-mb-[14px] tw-min-w-[185px] tw-max-w-[185px]">
                                                        <div className="tw-text-[18px]"> {(uom.UMDesc === "bx" || uom.UMDesc === "cs") && `${abbrToWord(uom.UMDesc)} of ${uom.UMQty} `} Each </div>
                                                        <div className="tw-text-[17px] tw-text-[#62A94B] tw-font-bold tw-leading-[17px]">
                                                            <span>Contract Price: </span><span>{'$' + (Math.round(uom.Price * 100) / 100).toFixed(2)}</span>
                                                        </div>
                                                        <div className="tw-text-[14px]">
                                                            <span>Standard:</span><del>{'$' + (Math.round(uom.ListPrice * 100) / 100).toFixed(2)}</del>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="tw-my-[12px]">
                                                {window.innerWidth >= 576
                                                    ? <label>
                                                        <input type="checkbox" className="contract-checkbox" onClick={addToContract.bind(this, item.ItemID)} />
                                                        <span>Apply this item to your Contract Pricing List?</span>
                                                    </label>
                                                    : <div className="tw-flex tw-gap-[8px] tw-mb-[22px] tw-flex-col">
                                                        <div className="tw-cursor-pointer tw-w-full sm:tw-w-[198px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[14px]"
                                                            onClick={addToContract.bind(this, item.ItemID)}>
                                                            APPLY TO CONTRACT
                                                        </div>
                                                        <div style={{ border: "1.5px solid #A71636", display: 'inline-flex' }} onClick={() => setUpdateCart(null)}
                                                            className="maybe-later tw-cursor-pointer tw-w-full sm:tw-w-[198px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-font-bold tw-text-[14px] hover:tw-bg-tamarillo-700 hover:tw-text-white">
                                                            MAYBE LATER
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {isLoading &&
                                            <div id="AnimationContainer" className="tw-absolute tw-top-0 tw-bottom-0 tw-right-0 tw-left-0 tw-text-center tw-content-evenly">
                                                <i className="fas fa-spinner fa-spin" id="SpinnerAnimation"></i>
                                            </div>}
                                    </div>
                                    <AddToContractHandleError updateCart={updateCart} itemIndex={i} hasErrorGlobal={hasErrorGlobal} />
                                </div></>
                        }
                    </div >
            })}
            {
                (response?.itemGroupModel.length > 0) &&
                <div className="tw-px-[19px] sm:tw-pl-[32px] sm:tw-pr-[21px]">
                    <div className="tw-text-[15px] tw-mt-[10px]">
                        You May Also Like
                    </div>
                    <CategoryContainer cartModel={response} />
                </div>
            }
        </>
    )

    function addToContract(itemID, event) {
        setIsLoading(true);
        const checkBox = $(event.currentTarget);
        checkBox.parents('.contract-container').css({ 'opacity': '0.4', 'pointer-events': 'none' });
        $.ajax({
            url: '/ShoppingCart/AddItemToContract',
            dataType: "json",
            type: "Post",
            async: true,
            data: { ItemID: itemID },
            success: function (data) {
                if (data?.substring(0, 7) === 'Success') {
                    finishAddToContract(checkBox, 'Added to Contract', '#62A94B');
                    checkBox.prop("checked", true);
                    //Instantly update table to show that this item is now in contract.
                    updateCart.ItemList[updateCart.ItemList.findIndex(item => item.ItemID === itemID)].OnContract = true;
                    setItems([...updateCart.ItemList]);
                }
                else finishAddToContract(checkBox, 'Error adding to contract', '#A71635');
            },
            error: () => finishAddToContract(checkBox, 'Error adding to contract', '#A71635')
        });
    }

    function finishAddToContract(element, msg, color) {
        const contractMessage = $(element).parents('.contract-menu').siblings('div').find('.contract-message');
        contractMessage.text(msg);
        contractMessage.css(({ 'color': color }));
        contractMessage.show();
        $(element).parents('.contract-container').css({ 'opacity': '1', 'pointer-events': 'auto' });

        if (window.innerWidth >= 576) {
            $(element).parents('label').prop("disabled", true);
            $(element).parents('label').css({ 'opacity': '0.4', 'pointer-events': 'none' });
        }
        else setTimeout(() => {
            $(element).siblings('.maybe-later').hide(), 200;
            $(element).css({ 'opacity': '0.4', 'pointer-events': 'none' })
        });
        setIsLoading(false);
    }
}

const AddToContractHandleError = ({ updateCart, itemIndex, hasErrorGlobal }) => {
    const [hasErrorLocal, setHasErrorLocal] = useState(false);

    useEffect(() => {
        let hasError = false;
        updateCart.ItemList[itemIndex].UoMPrices.forEach((uom, uomIndex) => {
            if (uom.QtyDiff > 0 && uom.MessageCode === 'Error') {
                revertQuantity(updateCart, itemIndex, uomIndex);
                hasErrorGlobal.current = true;
                hasError = true;
            }
        })
        if (hasError) setHasErrorLocal(hasError);
    }, []);

    return (hasErrorLocal &&
        <div className="uom-message tw-italic tw-text-[14px] tw-content-center tw-mb-[3px] tw-text-[#A71635] tw-mt-[8px]">
            There was an error adding at least one of the items above.
        </div>)
}

const UoMDetails = ({ updateCart, itemIndex, uomIndex, hasErrorGlobal }) => {
    const item = updateCart.ItemList[itemIndex];
    const uom = uomIndex !== null ? item.UoMPrices[uomIndex] : null;
    if (uom && uom.QtyDiff < 1) return;
    const [itemName, description] = item.SDname.split(',');
    let hasError = false;
    if (item.AddToContract !== 'Y') {
        hasError = uom.MessageCode === 'Error';
        useEffect(() => {
            if (hasError) {
                revertQuantity(updateCart, itemIndex, uomIndex);
                hasErrorGlobal.current = true;
            }
        }, []);
    }

    return (
        <div className={"tw-flex tw-flex-col tw-w-full " + (uomIndex === null && "tw-pt-[13px]")}>
            <div className={"tw-flex tw-gap-[25px] tw-justify-center " + (uomIndex === null && "tw-pb-[15px]")}>
                <div className="tw-flex tw-mt-[16px]">
                    <img width="191" src={`/Content/ProductImages/300x225/${item.ImageName}`} alt="Product image" />
                </div>
                <div className="tw-text-[14px] tw-content-center">
                    <div className="tw-text-[#A2A2A2] tw-font-thin">{item.ItemID}</div>
                    <div className="tw-text-[16px] tw-mb-[8px] tw-font-bold tw-leading-[19px]">{itemName}</div>
                    {item.AddToContract !== 'Y' && <div>Unit of Measure:&nbsp;<span className="tw-font-bold tw-uppercase">{abbrToWord(uom.UMDesc)}</span></div>}
                    <div>Description:&nbsp;
                        {!!description
                            ? <span className="tw-font-bold tw-uppercase" title={description.length > 16 ? description : ''}>
                                {description.length > 16 ? description.substring(0, 16) + '...' : description ?? 'N/A'}
                            </span>
                            : <span className="tw-font-bold tw-uppercase">N/A</span>
                        }
                    </div>
                    {item.AddToContract !== 'Y' && <div>Quantity:&nbsp;<span className="tw-font-bold">{uom.QtyDiff}</span></div>}
                </div>
            </div>
            {hasError &&
                <div className="uom-message tw-italic tw-text-[14px] tw-content-center tw-mb-[3px] tw-text-[#A71635] tw-mt-[8px]">
                    There was an error adding the item above.
                </div>
            }
        </div>
    )
}

const ItemsToRemove = ({ updateCart, hasErrorGlobal }) => {
    return (<>
        {!!updateCart.ItemsRemoved && <Header numberOfItems={updateCart.ItemsRemoved} />}
        {updateCart.ItemList.map((item, itemIndex) => {

            return !!item.UoMPrices.some(uom => uom.QtyDiff < 0) &&
                item.UoMPrices.map((uom, uomIndex) => {
                    if (uom.QtyDiff < 0) {
                        const [itemName, description] = item.SDname.split(',');
                        let hasError = uom.MessageCode === 'Error';
                        useEffect(() => {
                            if (hasError) {
                                revertQuantity(updateCart, itemIndex, uomIndex);
                                hasErrorGlobal.current = true;
                            }
                        }, []);

                        return (
                            <div className="tw-flex tw-flex-col tw-mx-[10px] sm:tw-mx-[36px] tw-max-h-[350px] tw-overflow-auto tw-pt-[10px] tw-text-[14px] tw-content-center tw-pb-[13px] tw-px-[12px] sm:tw-px-[14px]"
                                style={{ borderBottom: "1.5px solid #A2A2A2" }}>
                                <div className="tw-font-bold tw-text-tamarillo-700 tw-mb-[3px]">
                                    {`Removed ${Math.abs(uom.QtyDiff)} ${uom.QtyDiff < -1 ? 'units' : 'unit'} of ${uom.ItemID}`}
                                </div>
                                <div className="tw-text-[16px] tw-font-bold tw-leading-[19px]">{itemName}</div>
                                <div className="tw-flex tw-gap-[15px]">
                                    <div>Unit of Measure:&nbsp;<span className="tw-uppercase"></span>{abbrToWord(uom.UMDesc)}</div>
                                    <div>Description:&nbsp;
                                        <span className="tw-uppercase" title={description.length > 16 ? description : ''}>
                                            {description.length > 16 ? description.substring(0, 16) + '...' : description ?? 'N/A'}
                                        </span>
                                    </div>
                                </div>
                                {hasError &&
                                    <div className="uom-message tw-italic tw-text-[14px] tw-content-center tw-mb-[3px] tw-text-[#A71635] tw-mt-[8px]">
                                        There was an error removing the item above.
                                    </div>
                                }
                            </div>)
                    }
                })
        })}
    </>)
}

export const Footer = ({ updateCart, setUpdateCart }) => {
    const twoButtons = !!updateCart.ItemList.length && !!updateCart.Cart?.CartItems?.length && updateCart.GlobalError === 'NoStatus' && !updateCart.RestrictionTypes.length;
    return (
        <div className="modal-footer d-flex justify-content-center mt-2 tw-gap-[8px] tw-border-none tw-pb-[24px]">
            {twoButtons &&
                < div style={{ border: "1.5px solid #A71636" }} onClick={() => setUpdateCart(null)}
                    className="tw-cursor-pointer tw-w-full sm:tw-w-[198px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-font-bold tw-text-[14px] hover:tw-bg-tamarillo-700 hover:tw-text-white">
                    Continue Shopping
                </div>
            }
            <div className="tw-cursor-pointer tw-w-full sm:tw-w-[198px] tw-h-[41px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[14px]"
                onClick={() => twoButtons ? window.open('/ShoppingCart', '_self') : setUpdateCart(null)}>
                {twoButtons ? 'Checkout' : 'Continue Shopping'}
            </div>
        </div >
    );
}

export const CloseButton = ({ updateCart, setUpdateCart, bypassCheck = false }) => {
    return (
        (bypassCheck || (!updateCart.ItemsAdded && !updateCart.ItemsRemoved && updateCart.GlobalError !== 'QuoteProvided' && updateCart.GlobalError != null)) &&
        <div className="close tw-opacity-100 tw-cursor-pointer tw-absolute tw-right-[22px] tw-top-[13px] tw-bg-white tw-z-[1]" onClick={() => setUpdateCart(null)}>
            <img src="/Content/img/sprites/close-btn.svg" alt="Close" className="tw-w-[33px]" />
        </div>
    )
}

function abbrToWord(abbr) {
    return abbr === 'cs' ? "Case" : abbr === 'bx' ? 'Box' : 'Each';
}